import React from 'react'
import styled from 'styled-components'
import { device } from 'utils/device'

const DataSteward = ({ children }) => {
  return <Div>{children}</Div>
}

const Div = styled.div`
  font-size: 1rem;
  font-weight: 300;
  margin-top: 0.8rem;
  width: 70%;

  @media ${device.mobileL} {
    width: 100%;
    margin-bottom: 1rem;
  }
`

export default DataSteward
